var facetsToGridParams = require("../services/facetsToGridParamsService");
var utils = require("../utils");
const stringify = require("../json-stringify-safe");

$.fn.gridPageCtrl = function () {
  return this.each(function () {
    var $self = $(this);
    var $controller = $self.hasClass(".govuk-main-wrapper")
      ? $self
      : $self.closest(".govuk-main-wrapper");

    var $grid = $controller.find(".data-grid");
    var $facets = $controller.find(".facets");
    var $facetFilters = $facets.find(".filter-selector");
    var $activeFacets = $facets.find(".active-filters");  
    var $conditionalButtons = $controller.find(".js-conditional-button");

    var _model = {
      facet: {},
      facetRegistry: {},
      selectedRows: [],
      backendFacet: {
        pageSize: null,
        pageIndex: null,
        sortField: null,
        sortOrder: null,
        freetext: null,
        specificDate: null,
        datasetName: null,
        instanceName: null,
        organisationName: null,
        tagNames: null,
        dataSource: null,
        previousDataSource: null,
        bulkUploadId: null,
        startDate: null,
        endDate: null,
        organisationId: null,
        saved: false,
        submitted: false,
        certified: false,
      },
    };

    function _updateFacetModel(facetModel) {
      _model.facet[facetModel.id] = facetModel;
    }

    function _getNumberOfActiveFacets() {
      let numberOfActiveFacets = 0;
      for (let key in _model.facet) {
        if(_model.facet[key] && _model.facet[key].model && _model.facet[key].model.some(function (item) {
          return !!item.value && item.value.length !== 0;
        })) {
          numberOfActiveFacets++;
        }
      }
      if (!_model.facet.freetext && $('#search-textfield').val()) {
        // During initial page load, the freetext search is not preloaded like other facets, so count it this way
        numberOfActiveFacets++;
      }
      return numberOfActiveFacets;
    }

    function _handleClearAllFiltersVisibility() {
      const clearAllFilters = document.querySelector('.clear-all-filters')
      if (!clearAllFilters) return

      if (_getNumberOfActiveFacets() > 0) {
        clearAllFilters.removeAttribute('disabled')
      } else {
        clearAllFilters.setAttribute('disabled', 'disabled')
      }
    }

    function _clearSelectedFilter(clearButton){
      if(clearButton.getAttribute("filterName") == null){
          _model.facet[''].model = [];
      }
      else{
        _model.facet[clearButton.getAttribute("filterName")].model = [];
      }
      $controller.trigger("dclg.facets.applied", JSON.parse(stringify(_model)));

      if(clearButton.closest(".filter-selector").querySelector(".chosen-select")){ // if there is a select element remove the previous value
        $(clearButton.closest(".filter-selector").querySelector(".chosen-select")).val("").trigger("chosen:updated");
      }

      clearInputs(clearButton.parentNode.closest("div.govuk-accordion__section"));
      _updateActiveFiltersSummary();
      _handleClearAllFiltersVisibility();
      _triggerDataGridReload(_model.isInitialPageLoad);
    }

    function clearInputs(parent){
      if(parent.querySelector(".multiselect-chosen-options")){
        parent.querySelector(".multiselect-chosen-options").innerHTML = "";
      }
      if(parent.querySelectorAll("input").length > 0){
        let inputs = parent.querySelectorAll("input");

        for(let i = 0; i < inputs.length; i++){
          let input = inputs[i];
          if(input.type === "checkbox" || input.type === "radio"){
            input.checked = false;
          }
          else{
            input.value = '';
          }
        }
      }

    }

    function _updateActiveFiltersSummary() {
      var numberOfActiveFilters = 0;
      var activeFilters = [];
      for (let key in _model.facet) {
        if(
            _model.facet[key] &&
            _model.facet[key].model &&
            _model.facet[key].model.some(function (item) {
              return !!item.value && item.value.length !== 0;
            })
        ) {
          numberOfActiveFilters++;
          activeFilters.push(key);
        }
      }
      if (!_model.facet.freetext && $('#search-textfield').val()) {
        // During intial pageload, the freetext search is not preloaded like other facets, so count it this way
        numberOfActiveFilters++;
      }
      if (numberOfActiveFilters) {
        $('.active-filters-summary').show();
        $('.active-filters-summary-smaller').show();
        $('.active-filters-summary').text(`${numberOfActiveFilters} active filter${numberOfActiveFilters === 1 ? '' : 's'}`);
        $('.active-filters-summary-smaller').text(`${numberOfActiveFilters} active`);
      } else {
        $('.active-filters-summary').hide();
        $('.active-filters-summary-smaller').hide();
      }

      // Set the active tag visible or hidden for all components
      if (activeFilters.includes("Organisation") || activeFilters.includes("Collection")) {
        $('.collections-filter-active-tag').show();
      } else {
        $('.collections-filter-active-tag').hide();
      }

      if (activeFilters.includes("Status")) {
        $('.status-filter-active-tag').show();
      } else {
        $('.status-filter-active-tag').hide();
      }

      if (activeFilters.includes("Deadline")) {
        $('.deadline-filter-active-tag').show();
      } else {
        $('.deadline-filter-active-tag').hide();
      }

      if(activeFilters.includes("rangeFrom") || activeFilters.includes("rangeTo")){
        $('.date-window-filter-active-tag').show();
      } else{
        $('.date-window-filter-active-tag').hide();
      }
    }

    function _updateSelectedRowsModel() {
      var $selectedItems = $("#selectedItemsObject[type=hidden]");

      if ($selectedItems.length) {
        var model = JSON.parse(sessionStorage.getItem("sel"));

        _model.selectedRows = model.selected;

        $selectedItems.val(_filterSelectedRows(_model.selectedRows));
      } else {
        throw new Error(
          'Check that you have defined a "hidden" input element with ID "selectedItemsObject"',
        );
      }
    }

    function _filterSelectedRows(selectedRows) {
      if (!$.isArray(selectedRows)) {
        throw new Error(
          'This function expected an Array to have been passed in as an argument. Your argument is of type "' +
            typeof selectedRows +
            '"',
        );
      }

      // Remove the prefix 'grid_checkbox_' so that what's left is the 'ID'
      // e.g. 'grid_checkbox_23' has the ID of '23', which is what is saved
      // to 'selectedRows'
      selectedRows = $.map(selectedRows, function (item, index) {
        return item.replace("grid_checkbox_", "");
      });

      return selectedRows.join(",");
    }

    function _triggerRemoveFacet(data) {
      $facetFilters.trigger("dclg.facets.remove", data);
    }

    function _triggerSaveFacets(extraFields) {
      var defaultFacet = $.extend({}, _model.backendFacet, extraFields);

      var incomingFacet = facetsToGridParams(utils.copyObject(_model.facet));


      var combinedFacet = $.extend({}, defaultFacet, incomingFacet);

      // TODO?
      var saveAJAXObject = {
        type: $facets.attr("method") || "POST",
        data: combinedFacet,
        url: $facets.data("save-facets-endpoint"),
      };

      $("body").on("click", ".dialog-proceed", createSavedFiltersRecord);

      function createSavedFiltersRecord() {
        var $filtersEditView = $(this).closest("form");

        $.each($filtersEditView.serializeArray(), function () {
          var field = {};
          field[this.name] = this.value;
          $.extend(saveAJAXObject.data, field);
        });

        $.ajax(saveAJAXObject)
          .done(function (success) {
            //                    window.location.replace( $facets.attr('action') );
            window.location.assign($facets.attr("data-save-facets-endpoint"));
          })
          .fail(function (error) {
          });
      }
    }

    function _triggerDataGridReload(isInitialPageLoad) {
      var params = facetsToGridParams(utils.copyObject(_model.facet));

      var model = {
        params : params,
        isInitialPageLoad : isInitialPageLoad
      };
      $grid.trigger(
        "dclg.dataGrid.triggerReload",
        model,
      );
    }

    function _triggerDataGridClearSelection() {
      $grid.trigger("dclg.dataGrid.selection.clear");  
    }

    function _triggerClearAllFacets() {
      $facetFilters.trigger("dclg.facets.clear");
    }

    function _triggerResetFacetsToInitial() {
      $facetFilters.trigger("dclg.facets.reset");
    }

    function _triggerActiveFacetUpdate() {
      $activeFacets.trigger(
        "dclg.activeFacets.update",
        utils.copyObject(_model.facet),
      );
    }

    function _testEnablingDownloadCSVXMLButton() {
      var $element = $(".facets #datasetName[data-target]");
      var condition = $element.length ? $element.val().length > 0 : false;

      if (
        $element.data("target") === "download-csv" ||
        $element.data("target") === "download-xml"
      ) {
        if (condition) {
          utils.enableLinks($(".js-addGridQueryParamsOnclick"));
          utils.enableLinks($(".js-downloadXmlOnClick"));
          utils.enableLinks($(".js-exportToDapOnClick"));
        } else {
          utils.disableLinks($(".js-addGridQueryParamsOnclick"));
          utils.disableLinks($(".js-downloadXmlOnClick"));
          utils.disableLinks($(".js-exportToDapOnClick"));
        }
      } else {
      }
    }

    function _toggleConditionalButtons() {
      var id;
      var selectedCount = 0;

      selectedCount = _model.selectedRows.length;

      $conditionalButtons.each(function () {
        var $this = $(this);
        var min = 1;
        var max = $this.data("conditional-max")
          ? Number($this.data("conditional-max"))
          : Infinity;
        $this.prop("disabled", !(selectedCount >= min && selectedCount <= max));
      });
    }

    function _shouldFilterAutomaticallyApply(model){
      return $(".apply-all-filters").length === 0 || model.isInitialPageLoad || model.id === "freetext";
    }

    // ------------------------------
    // Facets listeners
    // ------------------------------
    //
    $controller.on("dclg.facets.changed", function (event, model) {
      $(".apply-all-filters").attr("disabled", false) // To activate 'Apply filters' button when you add any filter i.e org
        .attr("aria-disabled", false);
      _updateFacetModel(model);
     // only reload data for text search or when tables are not using the apply-all-filters button
      if(_shouldFilterAutomaticallyApply(model)){
        $(".apply-all-filters").attr("disabled", true) // To disable 'Apply filters' button, until someone changes anything on the filter
          .attr("aria-disabled", true);
        _updateActiveFiltersSummary();
        _handleClearAllFiltersVisibility();
        _triggerDataGridReload(model.isInitialPageLoad);

      }


      _triggerActiveFacetUpdate(); 
      _testEnablingDownloadCSVXMLButton();
      _triggerDataGridClearSelection();
    });

    $controller.on("dclg.facets.applied", function (model) {
      if (($(".searchform").length > 0 || $(".reset-all-filters").data("enabled")) && !model.isInitialPageLoad) {
         $(".reset-all-filters").removeClass("visually-hidden");
      }

      _updateActiveFiltersSummary();
      _handleClearAllFiltersVisibility();
      _triggerDataGridReload(model.isInitialPageLoad);
    });

    $controller.on("dclg.activeFacets.clearAllActive", function () {
      _triggerClearAllFacets();
    });
    $controller.on("dclg.activeFacets.resetToInitial", function () {
      _triggerResetFacetsToInitial();
    });

    $controller.on("dclg.activeFacets.removeFacet", function (event, data) {
      _triggerRemoveFacet(data);
    });

    $controller.on("dclg.activeFacets.saveAllActive", function (event, data) {
      _triggerSaveFacets(data);
    });

    $controller.on("dclg.activeFacets.clearSelected", function(event, clearButton){
      _clearSelectedFilter(clearButton)
    })

    // ------------------------------
    // Grid listeners
    // ------------------------------

    $controller.on("dclg.dataGrid.selection.change", function (event) {
      _updateSelectedRowsModel();
      _toggleConditionalButtons(event);
    });

    // ------------------------------
    // Initialisation
    // ------------------------------

    _toggleConditionalButtons();
    _handleClearAllFiltersVisibility();
    _updateActiveFiltersSummary()
    _testEnablingDownloadCSVXMLButton();
  });
};
